import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as RefreshCCWIcon } from './refreshCCW.svg';

export const RefreshCCW = IconHOC(RefreshCCWIcon);
